export enum StripeCurrency {
	usd = '$',
}

export enum StripeInvoiceStatus {
	draft = 'draft',
	open = 'open',
	paid = 'paid',
	uncollectible = 'uncollectible',
	void = 'void',
	refund = 'refund',
	partiallyRefunded = 'partiallyRefunded',
}
export enum CancelSubscriptionText {
	Cancel = 'cancel',
	Confirm = 'confirm',
	Error = 'error',
}
